export const ERROR_CONSTANTS = {
  UNEXPECTED_ERROR: 'An unexpected error occurred',
  CLIENT_ERROR: 'Client Error',
  UNAUTHORIZED: 'Unauthorized access. Please login again.',
  FORBIDDEN: 'Access forbidden. You do not have permission to perform this action.',
  NOT_FOUND: 'Resource not found.',
  VALIDATION_FAILED: 'Validation failed. Please check your input.',
  SERVER_ERROR: 'Internal server error. Please try again later.',
  SERVER_ERROR_PREFIX: 'Server Error',
  INVALID_CREDENTIALS:'Invalid Credentials'
} as const;

export const HTTP_STATUS_CODES = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500
} as const;